module.exports = __webpack_public_path__ + "static/media/Zero-Risk Bias - jason-dent-3wPJxh-piRw-unsplash.9e82c841.jpg";